import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import Loading from '../../pages/Loading'
import { getCurrentUser } from '../../../services/vu'

const mapStateToProps = ({ currentUser }) => {
  return {
    loading: currentUser.isFetching,
    userRole: currentUser.data['role']
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchCurrentUser: courseId => {
      dispatch(fetchCurrentUser(courseId))
    }
  }
}

const fetchCurrentUser = () => {
  return dispatch => {
    dispatch(requestCurrentUser())

    return getCurrentUser().then(currentUser => {
      return dispatch(receiveCurrentUser(currentUser))
    })
  }
}

const requestCurrentUser = () => {
  return {
    type: 'REQUEST_CURRENT_USER'
  }
}

const receiveCurrentUser = currentUser => {
  return {
    type: 'RECEIVE_CURRENT_USER',
    data: currentUser
  }
}

class CurrentUser extends Component {
  componentDidMount() {
    this.props.fetchCurrentUser()
  }

  render() {
    if (this.props.loading) {
      return <Loading />
    }

    return this.props.children
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CurrentUser)
)
